import React from 'react';
import { ReactComponent as Account } from './Account.svg';
import { ReactComponent as Admin } from './Admin.svg';
import { ReactComponent as BasicHauler } from './BasicHauler.svg';
import { ReactComponent as BasicProcessor } from './BasicProcessor.svg';
import { ReactComponent as BasicProducer } from './BasicProducer.svg';
import { ReactComponent as Bookmarks } from './Bookmarks.svg';
import { ReactComponent as CreationZone } from './CreationZone.svg';
import { ReactComponent as Driver } from './Driver.svg';
import { ReactComponent as Files } from './Files.svg';
import { ReactComponent as Hauling } from './Hauling.svg';
import { ReactComponent as HelpCircle } from './HelpCircle.svg';
import { ReactComponent as Home } from './Home.svg';
import { ReactComponent as Invoicing } from './Invoicing.svg';
import { ReactComponent as Logout } from './Logout.svg';
import { ReactComponent as Memberships } from './Memberships.svg';
import { ReactComponent as Notification } from './Notification.svg';
import { ReactComponent as Payroll } from './Payroll.svg';
import { ReactComponent as Pooling } from './Pooling.svg';
import { ReactComponent as ProcessedFluids } from './ProcessedFluids.svg';
import { ReactComponent as Processor } from './Processor.svg';
import { ReactComponent as Producer } from './Producer.svg';
import { ReactComponent as ProducerBusiness } from './ProducerBusiness.svg';
import { ReactComponent as Quality } from './Quality.svg';
import { ReactComponent as RawMilk } from './RawMilk.svg';
import { ReactComponent as Receiving } from './Receiving.svg';
import { ReactComponent as Reports } from './Reports.svg';
import { ReactComponent as Route } from './Route.svg';
import { ReactComponent as Settings } from './Settings.svg';
import { ReactComponent as Silo } from './Silo.svg';
import { ReactComponent as SubAdmin } from './SubAdmin.svg';
import { ReactComponent as SubHauling } from './SubHauling.svg';
import { ReactComponent as SubProcessor } from './SubProcessor.svg';
import { ReactComponent as SubProducer } from './SubProducer.svg';
import { ReactComponent as Trailer } from './Trailer.svg';
import { ReactComponent as UsersAndAssets } from './UsersAndAssets.svg';
import { ReactComponent as UserSwitch } from './UserSwitch.svg';
import { ReactComponent as MooIntel } from './MooIntel.svg';

const iconMap = {
    Account,
    Admin,
    BasicHauler,
    BasicProcessor,
    BasicProducer,
    Bookmarks,
    CreationZone,
    Driver,
    Files,
    Hauling,
    HelpCircle,
    Home,
    Invoicing,
    Logout,
    Memberships,
    MooIntel,
    Notification,
    Payroll,
    Pooling,
    ProcessedFluids,
    Processor,
    Producer,
    ProducerBusiness,
    Quality,
    RawMilk,
    Receiving,
    Reports,
    Route,
    Settings,
    Silo,
    SubAdmin,
    SubHauling,
    SubProcessor,
    SubProducer,
    Trailer,
    UsersAndAssets,
    UserSwitch,
};

const renderIcon = (name, width = 18, height = 18) => {
    const Icon = iconMap[name];
    return Icon ? <Icon width={width} height={height} /> : <Home width={width} height={height} />;
};

export default renderIcon;
